






















































import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";
import { Cutter, CutterMaterial, getYoungsModulus } from "@/utils/cutter";

@Component
export default class CutterForm extends Vue {
  @Prop({ required: true }) cutter!: Cutter;
  @Prop({ required: true }) updateCutter!: (cutter: Cutter) => void;
  @Prop({ required: true }) deleteCutter!: () => void;

  valid = true;
  name = "New Cutter";
  material = CutterMaterial.carbide;
  materials = Object.values(CutterMaterial);

  numberFields = {
    diameter: { name: "Diameter (in)", value: 0 },
    length: { name: "Flute Length (in)", value: 0 },
    flutes: { name: "Number of Flutes", value: 0 },
    shankDiameter: { name: "Shank Diameter (in)", value: 0 },
    overallStickout: {
      name: "Overall Stickout (in)",
      value: 0,
    },
  };

  get youngsModulus() {
    return getYoungsModulus(this.material);
  }
  created() {
    this.name = this.cutter.name;
    this.material = this.cutter.material;
    for (const numberField of Object.keys(this.numberFields)) {
      this.numberFields[numberField].value = this.cutter[numberField];
    }
  }

  requiredRule(name: string) {
    return (v) => !!v || `${name} is required`;
  }

  validate() {
    //@ts-ignore
    this.$refs.form.validate();
    this.updateCutter({
      name: this.name,
      material: this.material,
      diameter: this.numberFields.diameter.value,
      length: this.numberFields.length.value,
      flutes: this.numberFields.flutes.value,
      shankDiameter: this.numberFields.shankDiameter.value,
      overallStickout: this.numberFields.overallStickout.value,
    });
  }

  reset() {
    //@ts-ignore
    this.$refs.form.reset();
  }
  resetValidation() {
    //@ts-ignore
    this.$refs.form.resetValidation();
  }
}
